import axios from "axios";
import { apis } from "utils/config";
import { History, Word } from "utils/types";

export const searchWorks = async ({
  keyword,
  filters,
  lemma_pos,
  collocate_pos,
  _limit,
  _page,
}: {
  keyword: string;
  filters?: string;
  lemma_pos?: string;
  collocate_pos?: string;
  _limit?: number;
  _page?: number;
}) => {
  const res = await axios.get<{
    data: Word[];
    total: number;
    matched_pos: string[];
  }>(
    apis.search({
      keyword,
      filters,
      lemma_pos,
      collocate_pos,
      _limit,
      _page,
    }).url
  );
  return res.data;
};

export const createHistory = async ({
  userId,
  data,
}: {
  userId: string;
  data: {
    keyword: string;
    filters: string;
    pos: string;
  };
}) => {
  const res = await axios.put(apis.history(userId).url, {
    query_keyword: data.keyword,
    query_filters: data.filters,
    query_pos: data.pos,
  });
  return res.data;
};

export const getHistories = async ({
  userId,
  query,
}: {
  userId: string;
  query: {
    _limit: number;
    after?: number;
    before?: number;
    last?: number;
  };
}) => {
  const res = await axios.get<{
    data: History[];
    after: number;
    before: number;
  }>(apis.history(userId, query).url);
  return res.data;
};

export const getDictionaries = async (keyword: string, lang: string) => {
  const res = await axios.get(apis.oxford(keyword, lang).url);
  return res.data;
};

export const getNewDictionaries = async (keyword: string) => {
  const res = await axios.get(apis.newDictionaries(keyword).url);

  return res.data;
};

export const getLocalSuggestions = async (keyword: string) => {
  const res = await axios.get(apis.localSuggestions(keyword).url);
  return res.data;
};

export const getCorrection = async (keyword: string) => {
  const res = await axios.get(apis.correction(keyword).url);
  return res.data;
};

export const getAllCollocations = async (keyword: string) => {
  const res = await axios.get(apis.allCollocations(keyword).url);
  return res.data;
};

export const getGgTranslation = async (keyword: string, lang: string) => {
  const res = await axios.post(apis.ggTranslation().url, {
    src: "en",
    target: lang,
    text: keyword,
  });
  return res.data;
};
